import * as React from "react";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class WhatsNewHeadings extends React.Component {
    constructor(props) {
        super(props);     
    }

    componentDidMount() {
        logUI("MBHWeb.UI.WhatsNewHeadings.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {

        let { ContentId, ContentName, content } = this.props;
       
        return (

            <div className="row">
                <div className="col-12">                                       
                    <h2 id={ContentId}>{ContentName}</h2>                  
                    {content && <div dangerouslySetInnerHTML={{ __html: content }}></div>}
                </div>
            </div>

        );
    }
};

export default WhatsNewHeadings;
